const styles = {
    title: {
        fontSize: 33,
        letterSpacing: -0.7,
        color: "#ffffff",
    },
    subtitle: {
        fontSize: 23,
        lineHeight: 1.31,
        color: "#ffffff"
    },
    button: {
        width: 178,
        height: 42,
        boxShadow: "0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12)",
        border: "solid 1px #ffd200",
        backgroundColor: "#333333"
    },
    buttonText: {
        fontSize: 23,
        textAlign: "center",
        color: "#ffffff"
    }
};

export default styles;


// WEBPACK FOOTER //
// ./src/pages/Customization/components/Modals/styles.js